import request from '@/utils/request';

export function fetchChatList(data: any) {
  return request({
    url: '/forehead/userChatSession/queryChatSessionList',
    method: 'post',
    data: data,
  });
}
export function fetchChat(data: any) {
  return request({
    url: '/forehead/chatMessage/queryMessageList',
    method: 'post',
    data: data,
  });
}
export function fetchShortcut(data: any) {
  return request({
    url: '/forehead/shortcut/queryList',
    method: 'post',
    data: data,
  });
}
const TENCENT_SIGN_POLL_INTERVAL_MS = 10_000;

let tencentSignPollTimer: ReturnType<typeof setInterval> | null = null;

export function fetchTencentSign(data: any) {
  return request({
    url: '/forehead/component/getTencentSign',
    method: 'post',
    data: data,
  });
}

/** Polls `getTencentSign` every 10s. Call `stopTencentSignPolling` on leave. */
export function startTencentSignPolling(resolvePayload: () => unknown): void {
  stopTencentSignPolling();
  const tick = (): void => {
    void fetchTencentSign(resolvePayload()).catch(() => {});
  };
  tick();
  tencentSignPollTimer = window.setInterval(tick, TENCENT_SIGN_POLL_INTERVAL_MS);
}

export function stopTencentSignPolling(): void {
  if (tencentSignPollTimer !== null) {
    window.clearInterval(tencentSignPollTimer);
    tencentSignPollTimer = null;
  }
}